
export const PAGE_DEFINITIONS = "/Page/GetPages"
export const PAGE_INSERT = "/Page/InsertPage"
export const PAGE_UPDATE = "/Page/UpdatePage"
export const PAGE_DELETE = "/Page/DeletePage"
export const PAGE_OPERATION = "/PageOperation/GetPageOperationListForRoleDefinition"
export const PAGE_OPERATION_FOR_VALUE = "/PageOperation/GetPageOperationForValueList"
